import { render, staticRenderFns } from "./NeedsUpdatesItem.vue?vue&type=template&id=4d5ab3d3&scoped=true&"
import script from "./NeedsUpdatesItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsUpdatesItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5ab3d3",
  null
  
)

export default component.exports